import { Ad, AdLocation } from "../types";

export default (ads: Ad[], location?: AdLocation, resourceId?: string): Ad[] | null => {
	if (!ads) {
		return null;
	}

	if (location) {
		return ads.filter(ad => {
			if (!ad.location) {
				return true;
			}
			return ad.location.includes(location) || ad.location.includes(AdLocation.All);
		});
	}

	if (resourceId) {
		return ads.filter(ad => {
			if (ad.resources.length === 0) {
				return false;
			}
			return ad.resources.includes(resourceId);
		});
	}

	return null;
};
